import YandexMapApiService from '../../services/YandexMapApiService';
import yandexMapApiUseCase from './yandexMapApiUseCase';

const yandexMapApiFactory = yandexMapApiUseCase({
  YandexMapApiService: YandexMapApiService(),
});

export default yandexMapApiFactory;
